/**
 * Calculates the contrast text color for a given hex color
 * 
 * @param hex Color in hex
 * @returns Either black or white hex color code
 */
export function getContrastTextColor(hex: string): string {
  const sanitized = hex.replace('#', '');
  const r = parseInt(sanitized.slice(0, 2), 16);
  const g = parseInt(sanitized.slice(2, 4), 16);
  const b = parseInt(sanitized.slice(4, 6), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.6 ? '#000000' : '#ffffff';
}